import { call, put, takeLatest } from "redux-saga/effects";
import {
  getExercisesByIdsApi,
  searchExercisesApi,
} from "../../../api/exercises";
import { IBaseResponse } from "../../../interfaces/base";
import { IFetchExercisesAction } from "../../../interfaces/store/exercises-interface";
import {
  fetchExercisesSuccess,
  fetchExercisesFailed,
  fetchExercisesStart,
  fetchChosenExercisesStart,
  fetchChosenExercisesSuccess,
  fetchChosenExercisesFailed,
} from "./alt-exercises-slice";

function* _fetchExercises({ payload }: IFetchExercisesAction) {
  try {
    const { sort, filter, pagination, search } = payload;

    const response: IBaseResponse = yield call(searchExercisesApi, {
      sort: sort || { sortBy: "updatedAt", sortOrder: -1 },
      search,
      filter,
      pagination,
    });

    if (response.error) {
      yield put(fetchExercisesFailed(response.error));
    } else {
      yield put(fetchExercisesSuccess({ data: response.data }));
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(fetchExercisesFailed({ message: error.message }));
  }
}

function* _fetchChosenExercises({
  payload,
}: {
  payload: { exercisesIds: string[] };
  type: string;
}) {
  try {
    const { exercisesIds } = payload;
    const encodedIds = encodeURIComponent(JSON.stringify(exercisesIds));

    const response: IBaseResponse = yield call(
      getExercisesByIdsApi,
      encodedIds
    );

    if (response.error) {
      yield put(fetchChosenExercisesFailed(response.error));
    } else {
      yield put(fetchChosenExercisesSuccess(response.data));
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(fetchChosenExercisesFailed({ message: error.message }));
  }
}

function* altExercisesSaga() {
  yield takeLatest(fetchExercisesStart.type, _fetchExercises);
  yield takeLatest(fetchChosenExercisesStart.type, _fetchChosenExercises);
}

export default altExercisesSaga;
